import React from "react";
import dynamic from "next/dynamic";
const BodyScrollLock = dynamic(() => import("../../components/BodyScrollLock/BodyScrollLock"));

const NewsletterV2NcModal = (props) => {
  return (
    <div>
      <BodyScrollLock>{props.children}</BodyScrollLock>
    </div>
  );
};

export default NewsletterV2NcModal;
